var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IpcSimpleViewerComponent"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isIPC),expression:"isIPC"}]},[_c('p',[_vm._v(_vm._s(_vm.lang.infotext_1)+":")]),_vm._v(" "),_c('div',{staticClass:"svgContainer"},[_c('div',{staticClass:"svgSimplePCB",attrs:{"id":'svgSimplePCB_' + _vm.name}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31657ce2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/IpcSimpleViewerComponent.vue
// module id = null
// module chunks = 